<i18n lang="yaml" locale="en">
  fullscreen: Fullscreen
  ignore: Ignore
  name: Name
  click behaviour: Click behaviour
  caption: Caption
</i18n>

<i18n lang="yaml" locale="de">
  fullscreen: Vollbild
  ignore: Ignorieren
  name: Name
  click behaviour: Klickverhalten
  caption: Beschriftung
</i18n>

<template>
  <div
    @click.capture="handleFullscreen"
    class="other-file"
    :class="{'asset-browser-item': !isInProject && !isInPropEditor}"
  >
    <file
      ref="placeholder"
      class="content"
      :size="isInProject && !isInPropEditor ? 'full' : 's'"
    />
    <div
      v-if="isFullscreen && caption"
      class="caption"
    >
      {{ caption }}
    </div>
    <div
      v-if="!isInProject || isInPropEditor"
      class="name"
    >
      {{ name }}
    </div>
    <keep-alive>
      <FileEditor
        v-if="$editMode && !isInPropEditor"
        ref="editor"
      />
    </keep-alive>
  </div>
</template>

<script>
import File from '@/components/icons/File'
import FileEditor from '@/components/editor/FileEditor'
import BaseModule from '@/components/modules/BaseModule'
import translatable from '@/store/mixins/translatable'

export default {
  // eslint-disable-next-line vue/name-property-casing
  name: 'otherFile',
  extends: BaseModule,
  customStore: translatable,
  components: {
    File,
    FileEditor
  },
  props: {
    isInPropEditor: {
      type: Boolean,
      default: false
    },
    isFullscreen: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      required: true
    },
    ratio: {
      type: Number,
      default: undefined,
      min: 0
    },
    name: {
      type: String,
      default: '',
      input: 'text',
      label: 'name',
      condition: (values, path) => path.startsWith('/assets/')
    },
    // eslint-disable-next-line
    _headlineClickBehaviour: {
      input: 'heading',
      label: 'click behaviour',
      condition: (values, path) => !path.startsWith('/assets/')
    },
    clickBehaviour: {
      type: String,
      default: 'fullscreen',
      validator (value) {
        return ['fullscreen', 'none'].includes(value)
      },
      input: 'radio',
      choices: {
        fullscreen: 'fullscreen',
        none: 'ignore'
      },
      condition: (values, path) => !path.startsWith('/assets/')
    },
    // eslint-disable-next-line
    _headlineCaption: {
      input: 'heading',
      label: 'caption',
      condition: (values, path) => !path.startsWith('/assets/')
    },
    caption: {
      type: String,
      default: '',
      input: 'text',
      condition: (values, path) => !path.startsWith('/assets/')
    }
  },
  computed: {
    isInProject () {
      return !this.$store.getters.path.startsWith('/assets/')
    }
  },
  methods: {
    handleFullscreen () {
      if (this.isInProject && !this.$editMode && !this.isFullscreen && this.clickBehaviour === 'fullscreen') {
        this.$router.push({ path: this.$store.getters.path, query: { fullscreen: true } })
      }
    },
    getSize () {
      return {
        width: 1,
        height: 1
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.other-file {
  position: relative;
  overflow: hidden;

  .content {
    pointer-events: none;
  }
}
</style>
